import { Nav, Navbar } from 'react-bootstrap';
import { useLogicChallengeRoute } from 'sitemap';
import { useAppContext } from 'providers/AppProvider';
import { useEffect } from 'react';
import NavItem from './NavItem';

const NavbarLogicVerical = () => {
  const {
    config: { openNavbarVertical, navbarVerticalAppearance },
    setConfig
  } = useAppContext();

  const routes = useLogicChallengeRoute();

  useEffect(() => {
    setConfig({
      isNavbarVerticalCollapsed: true
    });
  }, []);
  return (
    <Navbar
      className="navbar-vertical"
      expand="lg"
      variant=""
      data-navbar-appearance={
        navbarVerticalAppearance === 'darker' ? 'darker' : ''
      }
    >
      <Navbar.Collapse id="navbarVerticalCollapse" in={openNavbarVertical}>
        <div className="navbar-vertical-content">
          <Nav className="flex-column" as="ul" id="navbarVerticalNav">
            {routes.map((route, idx) => (
              <NavItem route={route} key={idx} />
            ))}
          </Nav>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavbarLogicVerical;
